module.exports = {
    "baseUrl": "https://stagingnew.trillium.health",
    "ClinicBaseUrl": "https://api-v4.staging.primrose.health",
    "systemName": "System dev"
}